// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3H1WN","fileBtn":"File_fileBtn__sNj5q","closeBtn":"File_closeBtn__1B33Y","fileSelected":"File_fileSelected__WCko4","disabled":"File_disabled__378O8"};